import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import products from "../data/products";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

const Products = () => (
  <>
    <section className="page-hero">
      <motion.div
        className="page-hero__inner"
        initial="hidden"
        animate="visible"
        variants={fadeUp}
      >
        <p className="eyebrow">Our products</p>
        <h1>Four products. One platform DNA.</h1>
        <p className="page-hero__lead">
          We build modular business software for industries we know well —
          ERP for SMBs and manufacturers, plus dedicated systems for courier,
          medical, and education.
        </p>
      </motion.div>
    </section>

    <section className="section">
      <div className="products-grid">
        {products.map((p, i) => (
          <motion.article
            key={p.slug}
            className={"product-card" + (p.flagship ? " product-card--flagship" : "")}
            style={{ "--product-accent": p.accent }}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.45, delay: i * 0.07 }}
          >
            {p.flagship && <div className="product-card__badge">Flagship</div>}
            <div className="product-card__icon" aria-hidden>{p.icon}</div>
            <h3>{p.name}</h3>
            <p className="product-card__tagline">{p.tagline}</p>
            <p className="product-card__blurb">{p.blurb}</p>
            <ul className="product-card__features">
              {p.features.slice(0, 4).map((f) => (
                <li key={f.title}>
                  <span aria-hidden>{f.icon}</span> {f.title}
                </li>
              ))}
            </ul>
            <Link to={`/products/${p.slug}`} className="btn-secondary">
              Learn more →
            </Link>
          </motion.article>
        ))}
      </div>
    </section>

    <section className="cta-strip">
      <div className="cta-strip__inner">
        <div>
          <h2>Not sure which fits?</h2>
          <p>Tell us about your business — we’ll point you to the right product.</p>
        </div>
        <Link to="/contact" className="btn-primary btn-primary--inverse">
          Talk to us
        </Link>
      </div>
    </section>
  </>
);

export default Products;
